import { InstrumentDetail, InstrumentUpdatePayload, Sector } from "../types"

/**
 * Organizes sectors array by level index.
 * The form expects sectors at specific indices: L1 at index 0, L2 at index 1, L3 at index 2.
 * The API might return sectors in any order, so we need to reorganize them.
 */
export const organizeSectorsByLevel = (sectors: Sector[]): (Sector | undefined)[] => {
  const organized: (Sector | undefined)[] = [undefined, undefined, undefined]
  for (const sector of sectors) {
    if (sector && sector.level >= 1 && sector.level <= 3) {
      organized[sector.level - 1] = sector
    }
  }
  return organized
}

/**
 * Prepares instrument data for the form by organizing sectors by level.
 */
export const prepareInstrumentForForm = (instrument: InstrumentDetail): InstrumentDetail => {
  return {
    ...instrument,
    sectors: organizeSectorsByLevel(instrument.sectors) as Sector[],
  }
}

/**
 * Formats the instrument data for the update API.
 * Includes sectors and asset_type.
 */
export const formatInstrumentForUpdate = (instrument: InstrumentDetail): InstrumentUpdatePayload => {
  const payload: InstrumentUpdatePayload = {
    sectors: [],
    asset_type: instrument.asset_type,
  }

  if (instrument.can_edit_sectors) {
    payload.sectors = instrument.sectors
      .filter(sector => sector != null)
      .map(sector => ({
        id: sector.id,
        level: sector.level,
      }))
  }

  return payload
}
